import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import "./styles/colors_and_type.css";
import "./styles/styles.css";

import { Site } from "./components/Site";

const container = document.getElementById("root");
if (!container) throw new Error("#root is missing from index.html");

createRoot(container).render(
  <StrictMode>
    <Site />
  </StrictMode>
);
